import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["theme"];
import React from 'react';
import { withTheme } from 'styled-components';
import defaultTheme from './defaultTheme';
import merge from '../utils/merge';
export default (function (Component) {
  var WithTheme = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: merge(defaultTheme, theme),
      ref: ref
    }, props));
  });
  WithTheme.defaultProps = {
    theme: defaultTheme
  };
  return withTheme(WithTheme);
});